import React from 'react';

import { getChainPrivateApi } from '#/api/apiCoreSdk';
import DownloadCsvButton from '#/components/wallet/DownloadCsvButton';

export default function DownloadFundingCSV({
  disabled,
}: {
  disabled: boolean;
}) {
  return (
    <DownloadCsvButton
      getDownloadUrl={wallet =>
        getChainPrivateApi().getInternalFundingHistoryCsvLink({ wallet })
      }
      title="Funding History"
      disabled={disabled}
    />
  );
}
